import Cookie from 'js-cookie';
import KM from '@ott/utility-km';
import { determineLayoutContext } from '@ott/layout-context';

export default function (name, options = {}, meta = {}) {
  const vid = Cookie.get('vid');
  const abst = Cookie.get('abst');
  const referrer = Cookie.get('referrer');

  const newOptions = {
    ...options,
    obj: {
      ...options.obj,
      vid,
      referrer,
      abst,
      isMobile: determineLayoutContext().isMobileLayout,
    },
  };

  KM(name, newOptions, meta);
}
